<div class="hero-banner hero-banner-fas">
    <div _ngcontent-my-app-c5="" class="bg-img-banner col-12 p-0">
      <img _ngcontent-my-app-c5="" alt="" class="img-fluid" src="{{imgBg.Src}}">
    </div>
    <div class="col-12 col-sm-8 offset-sm-2 col-xl-6 content-header">
        <h1 class="text-center landing-fas-bannertitle">{{FindStoreConfigData.Title}}</h1>
    </div>
</div>

